import React from 'react';
import Author from '../../container/images/Author.jpg';

const AboutUsComponent = props =>{
    return(
        <div className="container my-3">
            <div className="row">
                <div className="col-md-6 col-lg-6">
                    <img src={Author} alt="Aayush Soni" className="img-fluid img-thumbnail"/>
                </div>
                <div className="col-md-6 col-lg-6 my-5">
                    <h1>Aayush Soni</h1>
                    <p>
                        Hello, My name is <span className="font-weight-bolder font-italic">Aayush Soni</span>. I'm the creator and founder of <strong>"The Sanctuary of Tomorrow"</strong>.I have created this website / platform for those people who are having difficulty in finding good courses, reading and making a career. I will provide you with things like Graphic designing, Computer Programming, Programming Language and UI/UX Designing books and courses. I'm here to provide you the best courses and learning materials. I will also help those here who are worried about their future.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default AboutUsComponent;